import { render, staticRenderFns } from "./StoreUpdateCustomFields.vue?vue&type=template&id=b8a98b7c&scoped=true&"
import script from "./StoreUpdateCustomFields.vue?vue&type=script&lang=js&"
export * from "./StoreUpdateCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a98b7c",
  null
  
)

export default component.exports